import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';

const GET_CONSULTANT_STATEMENT_YEARS = gql`
  query GetConsultantStatementYears($consultantUuid: ID!) {
    consultantStatementYears(consultantUuid: $consultantUuid)
  }
`;

const useConsultantStatementYears = (consultantUuid, skip = false) => {

  const { data, loading, error, refetch } = useQuery(GET_CONSULTANT_STATEMENT_YEARS, {
    variables: { consultantUuid },
    skip: skip || !consultantUuid,
  });

  return {
    allYears: data?.consultantStatementYears || null,
    loading,
    errorYear: error?.message || null,
    refetch,
  };
};

export default useConsultantStatementYears;
